// MÈCHE Editorial — small progressive enhancements
(function () {
  var header = document.querySelector('.site-header');
  var toggle = document.querySelector('.menu-toggle');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (main) { main.src = btn.getAttribute('data-thumb'); main.srcset = ''; }
    });
  });
  var select = document.querySelector('[data-variant-select]');
  if (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var price = document.querySelector('[data-price]');
      var btn = document.querySelector('[data-add-button]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      if (btn) {
        var available = opt.dataset.available === 'true';
        btn.disabled = !available;
        btn.textContent = available ? btn.dataset.label : 'Sold out';
      }
    });
  }
})();